import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requireSession } from '@/app/guards';
import { AppShell, NotFoundView, RouteErrorView } from '@/features/shell';

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    await requireSession(context.queryClient, location.href);
  },
  component: function AppLayout() {
    return (
      <AppShell>
        <Outlet />
      </AppShell>
    );
  },
  errorComponent: ({ error, reset }) => (
    <AppShell>
      <RouteErrorView error={error} reset={reset} />
    </AppShell>
  ),
  notFoundComponent: () => <NotFoundView />,
});
